
    export function FormatNumber(value, func) {
      value = value.replace(/\D/g,'');
      if(value < 100000000) {
        if(value !== "") {
          value = parseInt(value, 10);
        }
        func(value);
      }
    }


// WEBPACK FOOTER //
// ./src/utils/FormatFields.js